import {RHFAutocomplete} from './rhf-autocomplete';
import RHFSelect from "@/components/form/rhf-select";
import RHFTextField from "@/components/form/rhf-text-field";

// ----------------------------------------------------------------------

export const Field = {
    Text: RHFTextField,
    Select: RHFSelect,
    Autocomplete: RHFAutocomplete,

};
